export const localeDateTimeFormat = (
  date: Date,
  key?: string,
): [Date, { key?: string; locale?: string }] => {
  const dateTimeFormatLocaleOverride = [{ from: 'bs', to: 'hr' }, { from: 'sl', to: 'hr' }, { from: 'mk', to: 'hr' }];
  const currentLocale = useNuxtApp().$i18n.locale.value;
  const overrideLocale = dateTimeFormatLocaleOverride.find((l) => l.from === currentLocale)?.to;
  return [date, { key, locale: overrideLocale }];
};
